"use client";
import { Box, IconButton } from "@mui/material";
import { OpenInFullRounded as ExpandIcon } from "@mui/icons-material";

import { useStore, observer } from "../../../../../../../service/mobx";

function ExpandImage({ src, alt }) {
  const { analytics, dialog } = useStore();

  return (
    <IconButton
      onClick={() => {
        analytics.track.event("Article Image Expand");
        dialog.configure({
          headline: " ",
          Content: () => (
            <Box
              component="img"
              src={src}
              alt={alt || "image"}
              maxWidth="100%"
              m="auto !important"
            />
          ),
          fullScreen: true,
          sx: {
            headline: {
              bgcolor: "var(--surface-container-lowest)",
              width: "fit-content"
            },
            paper: {
              p: 2,
              bgcolor: "var(--surface-container-lowest)"
            }
          }
        });
      }}
      size="small"
      sx={{
        mb: 0.5,
        ml: "auto",
        display: "flex",
        "&:hover svg": {
          opacity: "100%"
        }
      }}
    >
      <ExpandIcon
        fontSize="small"
        sx={{
          color: "var(--secondary-color)",
          opacity: "50%"
        }}
      />
    </IconButton>
  );
}

export default observer(ExpandImage);
